import type { ToolpanelType } from '../../types/ToolpanelType';
import { selectActivePanel } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useActivePanel() {
  return useEagGridSelector(selectActivePanel);
}